import api from "api";

const cashierSessions = {
    list:    (slug, params = {}) =>
        api().get(`/establishments/${slug}/cashier-sessions`, { params }),
    show:    (slug, id) =>
        api().get(`/establishments/${slug}/cashier-sessions/${id}`),
    open:    (slug, payload) =>
        api().post(`/establishments/${slug}/cashier-sessions/open`, payload),
    close:   (slug, id, payload) =>
        api().post(`/establishments/${slug}/cashier-sessions/${id}/close`, payload),
    summary: (slug, id) =>
        api().get(`/establishments/${slug}/cashier-sessions/${id}/summary`),
    productsSold: (slug, id, params = {}) =>
        api().get(`/establishments/${slug}/cashier-sessions/${id}/products-sold`, { params }),
    ticketsSold: (slug, id, params = {}) =>
        api().get(`/establishments/${slug}/cashier-sessions/${id}/tickets-sold`, { params }),
};

export default cashierSessions;
